export default "{\n    \"selfServiceLabel\": \"Plan de autoservicio\",\n    \"managedByResqLabel\": \"Administrado por ResQ\"\n}\n"